import { SVGProps } from 'react';

export default function FurnaceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect x='5.25' y='3' width='13.5' height='18' rx='1.5' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 7.5c-1.9 2.3-3.75 4-3.75 6.75a3.75 3.75 0 0 0 7.5 0c0-1.35-.55-2.55-1.5-3.75-.45 1.05-1.1 1.7-1.95 1.95.3-1.9.05-3.55-.3-4.95Z'
      />
    </svg>
  );
}
